import React, {useContext} from "react";
import {StepProps} from "../step-props";
import {forms} from "../forms";
import {Quotation} from "../../../model/quotation";
import {StepInformMessageDialog} from "../other/StepInformMessageDialog";
import {ScenarioContext} from "../../../contexts/ScenarioContext";
import { useHotjar } from "../../../utils/hooks/useHotjar";

export const GreenVerificationStep = ({step}: StepProps) => {
    const {stepMessages, setStepMessages} = useContext(ScenarioContext);
    const { trackHotjar} = useHotjar()

    const onVerify = (quotation: Quotation, paymentPageUrl: string) => {

        trackHotjar("confirm-number", "green-card");
        window.location.href = paymentPageUrl;
    };

    return (
        <>
            {step.forms.map(form => {
                return React.createElement(forms[form.code], {
                    key: form.code,
                    onVerify
                })
            })}

            <StepInformMessageDialog open={stepMessages.length > 0}
                                     acceptClickListener={()=>{
                                         setStepMessages([]);
                                     }}
                                     onClose={event => {
                                         setStepMessages([]);
                                     }}
                                     messages={stepMessages}/>
        </>
    );
};
